import { type FC, useId } from 'react'
import { useIntl } from 'react-intl'

import { FormControl, FormLabel, Input, Option, Select } from 'base-ui'

import { type ContactFormState } from '../../../contact-form'

type Props = {
  formState: ContactFormState
}

export const DirectContactFormSelectInputField: FC<Props> = ({ formState }) => {
  const intl = useIntl()
  const { model } = formState

  const orderNumberId = useId()

  const options = [
    intl.formatMessage({
      id: 'contactForm.select.item.changeDeliveryAddress',
    }),
    intl.formatMessage({ id: 'contactForm.select.item.changeName' }),
    intl.formatMessage({ id: 'contactForm.select.item.bankDetails' }),
    intl.formatMessage({ id: 'contactForm.select.item.orderQuestion' }),
    intl.formatMessage({
      id: 'contactForm.select.item.additionalOrder',
    }),
    intl.formatMessage({ id: 'contactForm.select.item.claim' }),
    intl.formatMessage({ id: 'contactForm.select.item.returns' }),
    intl.formatMessage({ id: 'contactForm.select.item.consultation' }),
    intl.formatMessage({ id: 'contactForm.select.item.priceInquiry' }),
    intl.formatMessage({
      id: 'contactForm.select.item.productInquiry',
    }),
    intl.formatMessage({ id: 'contactForm.select.item.suggestions' }),
    intl.formatMessage({ id: 'contactForm.select.item.miscellaneous' }),
  ]

  return (
    <div className="mb-2 grid gap-3.5 tablet:grid-cols-2">
      <Select
        className="text-m font-medium"
        onChange={(event, value): void => {
          if (!value) {
            return
          }
          formState.setValue(value, model, 'subject')
        }}
        placeholder={intl.formatMessage({ id: 'general.label.subject' })}
        slotProps={{
          root: {
            'aria-label': intl.formatMessage({ id: 'general.label.subject' }),
          },
        }}
        value={model.subject}
      >
        {options.map((translation) => {
          return (
            <Option key={translation} value={translation}>
              <span className="flex w-full justify-start">{translation}</span>
            </Option>
          )
        })}
      </Select>

      <FormControl
        data-qa-id="message-form-§emailForm.orderId"
        onChange={(event): void => {
          formState.makeInputProps('orderId').onChange(event)
        }}
        value={model.orderId}
      >
        <FormLabel htmlFor={orderNumberId}>
          {intl.formatMessage({
            id: 'general.form.label.orderNumber',
          })}
        </FormLabel>
        <Input id={orderNumberId} />
      </FormControl>
    </div>
  )
}
